import { Component } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { ComDateComponent } from '@kv-common-components/kv-common-components';
import moment from 'moment';
import { Moment } from 'moment';

const MY_FORMATS = {
    parse: {
        dateInput: 'MM/YYYY',
    },
    display: {
        dateInput: 'MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};
@Component({
    selector: 'app-date-component',
    templateUrl: './date.component.html',
    styleUrls: ['./date.component.scss'],
    providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }],
})
export class DateComponent extends ComDateComponent {
    constructor() {
        super();
    }

    chosenYearHandler(normalizedYear: Moment) {
        const ctrlValue = this.checkDefaultValue();
        ctrlValue.year(normalizedYear.year());
        this.myControl.setValue(ctrlValue);
    }

    chosenMonthHandler(
        normalizedMonth: Moment,
        datepicker: MatDatepicker<Moment>
    ) {
        const ctrlValue = this.checkDefaultValue();
        ctrlValue.month(normalizedMonth.month());
        this.myControl.setValue(ctrlValue);
        datepicker.close();
    }

    protected checkDefaultValue() {
        if (!this.myControl.value) {
            this.myControl.setValue(moment());
        }
        return this.myControl.value;
    }
}
